import React, { Component } from 'react';
import {
    FormModalContainer,
    FormModalContent,
    FinishButton,
    SettingRow,
    SettingInput,
    SettingsTimeInput,
} from './style';
import { CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import { Toggler } from '../../Toggler';
import { Input } from '../../Inputs/InputContainer';
import { DurationInput } from '../../Inputs/DurationInput';

export class WorkoutPlanSettingsModal extends Component {
    state = {
        editDefaults: this.props.editDefaults,
        repsPerSet: this.props.repsPerSet,
        setsPerExercise: this.props.setsPerExercise,
        circuits: this.props.circuits,
        intervalWorkout: this.props.intervalWorkout,
        duration: this.props.duration,
        setRestDuration: this.props.setRestDuration,
        roundRestDuration: this.props.roundRestDuration,
    };

    makeEditable = value => {
        this.setState({ editDefaults: value });
    };

    toggleWorkoutInterval = value => {
        this.setState({ intervalWorkout: value });
    };

    handleInputChange = event => {
        // let validatedValue = validateInputsInstantly(event);
        this.setState({ [event.target.name]: event.target.value });

        // TODO: validate in order to disable submit button
    };

    handleTimeChange = ({ hours, minutes, seconds }, name) => {
        const timeValue = `${hours}:${minutes}:${seconds}`;
        this.setState({ [name]: timeValue });
    };

    submitSettings = () => {
        const { defineSettings, onClose } = this.props;
        defineSettings(this.state);
        onClose();
    };

    render() {
        const {
            props: { onClose },
            state: {
                editDefaults,
                repsPerSet,
                setsPerExercise,
                circuits,
                intervalWorkout,
                duration,
                setRestDuration,
                roundRestDuration,
            },
            makeEditable,
            toggleWorkoutInterval,
            handleInputChange,
            handleTimeChange,
            submitSettings,
        } = this;

        const disableGeneral = !editDefaults;
        const disableInterval = !editDefaults || !intervalWorkout;

        return (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        Advanced settings
                    </Text>

                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <div style={{ width: '100%', marginBottom: '20px' }}>
                        <SettingRow>
                            <SettingText>Edit defaults</SettingText>
                            <Toggler onChange={makeEditable} state={editDefaults} />
                        </SettingRow>

                        <SettingRow disabled={disableGeneral}>
                            <SettingText>Reps per set</SettingText>
                            <Input>
                                <SettingInput
                                    value={repsPerSet}
                                    name={'repsPerSet'}
                                    onChange={handleInputChange}
                                    disabled={disableGeneral}
                                />
                            </Input>
                        </SettingRow>

                        <SettingRow disabled={disableGeneral}>
                            <SettingText>Sets per exercise</SettingText>
                            <Input>
                                <SettingInput
                                    value={setsPerExercise}
                                    name={'setsPerExercise'}
                                    onChange={handleInputChange}
                                    disabled={disableGeneral}
                                />
                            </Input>
                        </SettingRow>

                        <SettingRow disabled={disableGeneral}>
                            <SettingText>Rounds / Circuits</SettingText>
                            <Input>
                                <SettingInput
                                    value={circuits}
                                    name={'circuits'}
                                    onChange={handleInputChange}
                                    disable={disableGeneral}
                                />
                            </Input>
                        </SettingRow>

                        <SettingRow disabled={disableGeneral}>
                            <SettingText>Interval workout</SettingText>
                            <Toggler
                                disabled={disableGeneral}
                                onChange={toggleWorkoutInterval}
                                state={intervalWorkout}
                            />
                        </SettingRow>

                        <SettingRow disabled={disableInterval}>
                            <SettingText>Set duration</SettingText>
                            <DurationInput
                                disabled={disableInterval}
                                name={'duration'}
                                initial={duration}
                                component={SettingsTimeInput}
                                passData={handleTimeChange}
                            />
                        </SettingRow>

                        <SettingRow disabled={disableInterval}>
                            <SettingText>Rest between sets duration</SettingText>
                            <DurationInput
                                disabled={disableInterval}
                                name={'setRestDuration'}
                                initial={setRestDuration}
                                component={SettingsTimeInput}
                                passData={handleTimeChange}
                            />
                        </SettingRow>

                        <SettingRow disabled={disableInterval}>
                            <SettingText>Rest between rounds / circuits duration</SettingText>
                            <DurationInput
                                disabled={disableInterval}
                                name={'roundRestDuration'}
                                initial={roundRestDuration}
                                component={SettingsTimeInput}
                                passData={handleTimeChange}
                            />
                        </SettingRow>
                    </div>

                    <div style={{ width: '100%' }}>
                        <FinishButton onClick={submitSettings}>Finish</FinishButton>
                    </div>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

const SettingText = ({ children }) => (
    <Text fontSize={16} weight={100}>
        {children}
    </Text>
);

// TODO: create disableable wrapper



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/WorkoutPlanSettingsModal/index.js